import React from 'react'
import { Box, Drawer } from '@material-ui/core'
import ItemResolution from './ItemResolution'
import AddComment from './AddComment'
import styles from '../styles'

export const AgDetail = ({
  setOpenDetail,
  openDetail,
  copro_id,
  coproprietaire_id,
  ...props
}) => {
  const record = props.record
  const toggleDrawer = () => {
    setOpenDetail(!openDetail)
  }
  return (
    <>
      <React.Fragment key={'details-resolutions'}>
        <Drawer
          anchor={'right'}
          open={openDetail}
          onClose={toggleDrawer}
          style={styles.customDrawerPaper}
        >
          <Box>
            <AddComment
              copro_id={copro_id}
              coproprietaire_id={coproprietaire_id}
              record={record}
            />
          </Box>
          <Box>
            {record?.resolutions?.map((resolution) => {
              return <ItemResolution resolution={resolution} />
            })}
          </Box>
        </Drawer>
      </React.Fragment>
    </>
  )
}
export default AgDetail
